import { render, staticRenderFns } from "./coachViolation.vue?vue&type=template&id=4464b1dc&scoped=true&"
import script from "./coachViolation.vue?vue&type=script&lang=js&"
export * from "./coachViolation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464b1dc",
  null
  
)

export default component.exports